import React from 'react';
import { SupplierInfo } from '../types/supplierInfo.types';

interface DepositInfoSectionProps {
    supplierInfo: SupplierInfo;
}

const DepositInfoSection: React.FC<DepositInfoSectionProps> = ({ supplierInfo }) => {
    return (
        <div className="detail-card">
            <div className="detail-card-header">
                <i className="fas fa-university card-icon" />
                <h3 className="card-title">입금 정보</h3>
            </div>

            <div className="info-table">
                <div className="info-row">
                    <div className="info-label">은행명</div>
                    <div className="info-value">{supplierInfo.dpBankName || '-'}</div>
                    <div className="info-label">계좌번호</div>
                    <div className="info-value">{supplierInfo.dpAccountNumber || '-'}</div>
                </div>
                <div className="info-row">
                    <div className="info-label">예금주</div>
                    <div className="info-value">{supplierInfo.dpAccountName || '-'}</div>
                    <div className="info-label"></div>
                    <div className="info-value"></div>
                </div>
            </div>
        </div>
    );
};

export default DepositInfoSection;
